<template>
  <div id="index">
    <!-- :style="{'top': headerBodyTop + 'px'}" @mouseenter="headerStyleEn" @mouseleave="headerStyleLe"-->
    <div class="headerBody" ref="header">
      <console-header class="headerConsole" ref="headers"></console-header>
      <div class="arrow" @click="ChangeHeaderShow(ViewStyleTop?'hide':'')"  :style="{'top': ViewStyleTop==74?'-20px':'-74px'}" v-show="$route.path == '/CompanyConsole/indexPreview'">
        <!-- <div class="arrowBg"></div> -->
        <i class="el-icon-d-arrow-left icon" :style="{'transform': ViewStyleTop==0?'rotate(270deg)':'rotate(90deg)'}"></i>
      </div>
    </div>
    <div class="children-view" :style="{'top':ViewStyleTop+'px','min-height': HTMLminHeight+'px','min-width': HTMLminWidth+'px'}">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :companyId="companyId" :createdTime="companyCreatedTime"></router-view>
    </div>
    <div class="mask" id="maskId" v-show="$store.state.mask&&$route.path!='/CompanyConsole/indexPreview'"></div>
  </div>
</template>
<script>
  import consoleHeader from '../components/PublicAssembly/consoleHeader'
  export default {
    data() {
      return {
        HTMLminHeight: 694,
        HTMLminWidth: 1560,
        companyId: null,
        companyCreatedTime: null,
        ShowHeader: true,
        ViewStyleTop: 74,
        options: {},
        client: {},
        headerBodyTop: 0,
        TimeoutMark: false,
        timeout: null
      }
    },
    created() {
      this.companyId = Number(sessionStorage.getItem('companyId')||localStorage.getItem('companyId'));
      sessionStorage.setItem('companyId',this.companyId);
      this.$store.state.userData = {
        avatar: ''
      }
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store')||localStorage.getItem("store"))))
      if(!sessionStorage.getItem("companyIndexPreviewUrl")){
        sessionStorage.setItem("companyIndexPreviewUrl",this.$store.state.companyIndexPreviewUrl)
      }
      this.$store.state.companyIndexPreviewUrl = sessionStorage.getItem("companyIndexPreviewUrl")
      // console.log(sessionStorage.getItem("companyIndexPreviewUrl"),this.$route)
      if(this.$store.state.companyIndexPreviewUrl!=this.$route.fullPath&&this.$route.path=='/CompanyConsole/indexPreview'){
        this.$router.replace({
          path: this.$store.state.companyIndexPreviewUrl
        })
        return
      }
      this.$store.state.companyId = this.companyId
      this.$store.state.broadcasting = false
      this.changeTitle()
      this.companyCreatedTime = this.$store.state.companyCreatedTime;
      this.getUserConfig()
    },
    mounted() {
      //      this.$store.state = JSON.parse(sessionStorage.getItem("state"))
      if (this.$route.path == '/CompanyConsole/DataAnalytical') {
        this.HTMLminHeight = 800
      }
      if (this.$route.path == '/CompanyConsole/IndexEdit'||this.$route.path == '/CompanyConsole/IndexEditShow'||this.$route.path == '/CompanyConsole/deviceList') {
        this.HTMLminWidth = 1902
      }
    },
    computed: {
      MinWidth() {
        return this.$store.state.HTMLminWidth;
      },
    },
    methods: {
      /*鼠标移出 改变头部样式*/
      headerStyleLe() {
        if (this.$route.path != '/CompanyConsole/IndexEditShow') return;
        this.TimeoutMark = false
        this.timeout = setTimeout(() => {
          if (!this.TimeoutMark) {
            this.headerBodyTop = -74
            this.ViewStyleTop = 0
            this.timeout = null
            this.$nextTick(() => {
              setTimeout(() => {
                /*根据组态类型判断需要执行的resize方法*/
                this.Resize();
              }, 400)
            })
          }
        }, 1000)
      },
      /*鼠标移入 改变头部样式*/
      headerStyleEn() {
        if (this.$route.path != '/CompanyConsole/IndexEditShow') return;
        if (this.timeout) {
          clearTimeout(this.timeout)
        };
        this.TimeoutMark = true
        this.headerBodyTop = 0
        this.ViewStyleTop = 74

        this.$nextTick(() => {
          setTimeout(() => {
            /*根据组态类型判断需要执行的resize方法*/
            this.Resize();
          }, 400)
        })
      },
      Resize() {
        /*根据组态类型判断需要执行的resize方法*/
        if (this.$refs.index) {
          if (this.$refs.index.type == 2) {
            this.$refs.index.onWindowResize();
          } else {
            this.$refs.index.chartsDomUpdate();
          }
        }
      },
      changeHeaderStyle(navItem, gradItem) {
        this.$refs.header.updateStyle(navItem, gradItem)
      },
      changeHeight(h){
        this.HTMLminHeight = h
      },
      ChangeHeaderShow(type) {
        // console.log(type)
        if (type == 'hide') {
          this.ShowHeader = false;
          this.ViewStyleTop = 0;
        } else {
          this.ShowHeader = true;
          this.ViewStyleTop = 74;
        }
      },
      changeTitle() {
        this.get('/Company/get', {
          id: this.companyId
        }).then((res) => {
          if (res.success) {
            //console.log(res.result)
            let icon = res.result.logo; // 图片地址
            this.$store.state.companyLogo = icon
            let origin = window.location.protocol + '//' + window.location.hostname
            icon = origin + icon
            this.changeFavicon(icon); // 动态修改网站图标
            let title = res.result.title; // 网站标题
            // console.log(this.$route)
            if(this.$route.path=='/CompanyConsole/DataAnalytical'){
              title='数据分析 - '+title
            }
            document.title = title; // 动态修改网站标题
            this.$store.state.companyTitle = title;
            this.$store.state.companyCode = res.result.code;
            let options = {
              clientId: this.$store.state.userData.code + '_' + this.$store.state.companyCode+"_company",
              connectTimeout: 600000,
              clean: true
            }
            this.$store.state.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
            this.client = this.$store.state.client
            this.mqttMSG(this.$store.state.userData.code)
          } else {
            this.$message({
              message: `${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      changeFavicon(link) {
        //console.log('link',link)
        let $favicon = document.querySelector('link[rel="icon"]');
        if ($favicon !== null) {
          $favicon.href = link;
        } else {
          $favicon = document.createElement("link");
          $favicon.rel = "icon";
          $favicon.href = link;
          document.head.appendChild($favicon);
        }
        this.$forceUpdate()
      },
      // //获取系统配置
      // getData(){
      //     this.get('/SystemConfig/getList').then((res)=>{
      //         if(res.success){
      //             for(let obj of res.result){
      //                 if(obj.name=='guestTime'){
      //                     let value = obj.value==null?5:obj.value
      //                     localStorage.setItem('guestTime',value)
      //                     this.lookTime(value)
      //                 }else if(obj.name == 'verifyCodeModule'){
      //                     let value = obj.value
      //                     localStorage.setItem('verifyCodeModule',value)
      //                     console.log(value)
      //                 }
      //             }
      //         }
      //     })
      // },
      mqttMSG(code) {
        // mqtt连接
        let url = 'sys/user/' + code + '/message/push'
        this.client.subscribe(url, {
          qos: 1
        }, (error) => {
          if (!error) {
            // console.log('订阅用户消息成功')
          } else {
            // console.log('订阅用户消息失败')
          }
        })
        // 接收消息处理
        this.client.on('message', (topic, message) => {
          if (topic == url) {
            this.getMessagelist({
              pageNumber: 1,
              length: this.$store.state.userConfig.rowsPerPage
            })
          }
        })
        // 链接异常处理
        this.client.on('error', (error) => {
          // console.log('连接失败:', error)
          // this.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.options)
        })
      },
      getMessagelist(parm) {
        this.get('/Message/query', parm).then((res) => {
          if (res.success) {
            this.$store.state.messageList = res.result.data
            this.$forceUpdate()
          } else {
            this.$message({
              message: `获取消息列表数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      //获取用户配置
      getUserConfig() {
        if (localStorage.getItem('rowsPerPage')) {
          this.$store.state.userConfig.rowsPerPage = Number(localStorage.getItem('rowsPerPage'))
          this.getMessagelist({
            pageNumber: 1,
            length: this.$store.state.userConfig.rowsPerPage
          });
          return
        }
        this.get('/UserConfig/get', {
          name: 'rowsPerPage'
        }).then((res) => {
          if (res.success) {
            this.$store.state.userConfig.rowsPerPage = res.result.value ? Number(res.result.value) : 10
            localStorage.setItem('rowsPerPage', res.result.value ? Number(res.result.value) : 10)
            // console.log(this.$store.state.userConfig.rowsPerPage)
            this.getMessagelist({
              pageNumber: 1,
              length: this.$store.state.userConfig.rowsPerPage
            });
          }
        })
      },
    },
    components: {
      "console-header": consoleHeader,
    },
    watch: {
      MinWidth(val) {
        this.HTMLminWidth = val
      },
    },
    beforeDestroy() {
      // console.log('Destroy')
      this.$refs.headers.Destroy()
    }
  }
</script>
<style scoped>
  .headerBody {
    background-color: #F7F7F7;
    position: absolute;
    width: 100%;
    transition: .4s;
  }

 /* .arrow .arrowBg {
    background-image: url(../assets/image/indexEditor/arrow2.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 14px;
    position: absolute;
    width: 14px;
    height: 14px;
    top: 4px;
    left: 26;
    margin: auto;
  } */
  .icon{
    color: #5087e4;
    font-size: 16px;
    transition: .4s;
    line-height: 20px;
    font-weight: bold;
  }
  .icon:hover{
    background-color: #fff;
  }
  .arrow {
    position: relative;
    top: 0;
    z-index: 5;
    width: 30px;
    /* background: #fff; */
    height: 20px;
    /* line-height: 20px; */
    text-align: center;
    transition: .4s;
    /* border: 1px solid #333; */
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .headerConsole {
    transition: .4s;
  }

  .children-view {
    position: absolute;
    width: 100%;
    /* top: 74px; */
    bottom: 0;
    min-width: 1560px;
    min-height: 694px;
    transition: .4s;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, .4);
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/components/consoleIndex.vue